import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const AllPolicies = lazy(() => import('@pages/producer/AllPolicies'));

export const AllPoliciesRoutes: RouteObject[] = [
  {
    path: '/all-policies',
    element: (
      <React.Suspense>
        <AllPolicies />
      </React.Suspense>
    ),
  },
];